import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //
//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { colData } from "./ReportTableColumns";
import { loadApAutoReports } from "../../../../redux/feature/reportSlice";
import CommonFilter from "../CommonFilter";

const ApAutoReportsDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Report");
  localStorage.setItem("submenu", "-");
  let reportInfo = useSelector((state) => state?.report); // Report Details from Store
  let reportData = useSelector((state) => state?.report?.supplierReport); // Report Details from Store
  let reportDatapagination = useSelector(
    (state) => state?.report?.supplierReport?.pagination
  );
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(100);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [filterShow, setFilterShow] = useState(false);

  const [getFilter, /*setFilter*/] = useState({});
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const loadReport = async () => {
    if (reportInfo?.data) {
      let obj = {
        queryName: reportInfo?.data?.queryName,
        page: 1,
        per_page: 100,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      dispatch(loadApAutoReports(obj));
      toast.dismiss(toastId);
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    if (reportInfo?.data?.queryName) {
      const reportCol = colData.find(
        (data) => data.name === reportInfo?.data?.queryName
      );
      if (reportCol) {
        setColumns(reportCol.columns);
      }
      loadReport();
      // getMasterData();
    } else {
      navigate(Constants.SUPPLIER_REPORTS);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTableData(reportData.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData]);

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: reportInfo?.data?.queryName,
      // module: "CUSTOMER",
      page: 1,
      per_page: 100,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(loadApAutoReports(obj));
    setTableData(reportData?.data);

  };
  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: reportInfo?.data?.queryName,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: reportInfo?.data?.queryName,
        page: page,
        per_page: getNewPerPage,
      };
    }
    dispatch(loadApAutoReports(obj));
    setTableData(reportData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: reportInfo?.data?.queryName,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: reportInfo?.data?.queryName,
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(loadApAutoReports(obj));
    setTableData(reportData?.data);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">{reportInfo?.data?.name}</h2>
            <p className="subText">Complete Details of the Reports</p>
            <hr />
            <Col
              xs={6}
              md={{ span: 2, offset: 10 }}
              lg={{ span: 2, offset: 10 }}
            >
              <span
                className="filterIcon"
                onClick={() => setFilterShow(!filterShow)}
              >
                <i class="bi bi-filter"></i>
              </span>
            </Col>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilter
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            {/* Datatable Section */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-down"
                          : "bi-chevron-right"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">R</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle"> Reports</span>
                      <span className="subHeaderTitle">Reports and Status</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={tableData}
                          progressPending={reportData?.status}
                          paginationRowsPerPageOptions={
                            Constants.ROW_REPORT_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationPerPage={100}
                          paginationTotalRows={reportDatapagination?.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default ApAutoReportsDetails;
